import styled from 'styled-components';
import { Card } from 'antd';

export const Div = styled.div`
    padding: 30px;
    background: #f5f5f5;
`

export const DivTitle = styled.div`
    text-align: center;
    margin-bottom: 2%;
`

export const Title = styled.h1`
    color: #DF8232;
`

export const SubTitle = styled.p`
    font-size: 15px;
`

const { Meta } = Card;
export const Descripcion = styled(Meta)`
    height: 20vh;  
`
